import { render, staticRenderFns } from "./FeaturedCategoriesTile.vue?vue&type=template&id=6516bc60&scoped=true&lang=pug&"
import script from "./FeaturedCategoriesTile.vue?vue&type=script&lang=js&"
export * from "./FeaturedCategoriesTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6516bc60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6516bc60')) {
      api.createRecord('6516bc60', component.options)
    } else {
      api.reload('6516bc60', component.options)
    }
    module.hot.accept("./FeaturedCategoriesTile.vue?vue&type=template&id=6516bc60&scoped=true&lang=pug&", function () {
      api.rerender('6516bc60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/FeaturedCategoriesTile.vue"
export default component.exports